import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './styles.mod.scss';
import ChevronDown from 'images/icons/controls/chevron-down.svg?react-svg';
import ChevronUp from 'images/icons/controls/chevron-up.svg?react-svg';

export default function StyledSelect({
  ArrowDown = ChevronDown,
  ArrowUp = ChevronUp,
  smallArrow,
  ...props
}) {
  const arrowProps = smallArrow
    ? { width: 11, height: 6, style: { verticalAlign: 1 } }
    : { width: 14, height: 8 };

  return (
    <Select
      arrowRenderer={({ isOpen }) =>
        isOpen ? <ArrowUp {...arrowProps} /> : <ArrowDown {...arrowProps} />
      }
      {...props}
    />
  );
}
